import React, {
    createContext,
    useCallback,
    useContext,
    useState,
    ReactNode,
} from "react";

type LocationData = {
    latitude: number;
    longitude: number;
};

type LocationContextType = {
    location: LocationData | null;
    error: string | null;
    declined: boolean;
    setDeclined: (value: boolean) => void;
    requestLocation: () => void;
};

const LocationContext = createContext<LocationContextType | undefined>(
    undefined
);

export const LocationProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const [location, setLocation] = useState<LocationData | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [declined, setDeclined] = useState(false);

    const requestLocation = useCallback(() => {
        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser.");
            setDeclined(true);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (pos) => {
                setLocation({
                    latitude: pos.coords.latitude,
                    longitude: pos.coords.longitude,
                });
                setError(null);
                setDeclined(false);
            },
            (err) => {
                console.log('awfasdf', err);
                setError(err.message);
                setDeclined(true);
            }
        );
    }, []);

    return (
        <LocationContext.Provider
            value={{
                location,
                error,
                declined,
                setDeclined,
                requestLocation,
            }}
        >
            {children}
        </LocationContext.Provider>
    );
};

export const useLocationAccess = (): LocationContextType => {
    const ctx = useContext(LocationContext);
    if (!ctx) {
        throw new Error("useLocationAccess must be used within a LocationProvider");
    }
    return ctx;
};
